<template>
	<div box class="tgl">
		<p desc>{{$t("advancedTab.tglInfo")}}</p>
		<ul>
			<li tgl :data-desc="$t('advancedTab.tglInfo')">
        <div itemlist>
          <p></p>
          <el-input ref="key" @focus="k0Focus" @keydown.native="handleKeydownKey" v-model="setButton" :placeholder="$t('advancedTab.setButton')" class="name" clearable readonly></el-input>
        </div>

				<p :data-name="$t('advancedTab.recordButton')" content>
          <el-input ref="k1" @focus="k1Focus" :placeholder="$t('advancedTab.continueFun')" v-model="c1"  @keydown.native="handleKeydown" clearable readonly></el-input>
				</p>

				<p title>{{$t("advancedTab.continueFunDelay")}}（MS)</p>
        <div class="block">
          <el-slider @change="setDelay" :value ="delay" :min=200 :max=1000 :step=1 show-input width="200px" clearable> </el-slider>
        </div>

			</li>
      <li><buttonPaneC @child-event="setKey"></buttonPaneC></li>
    </ul>
  </div>
</template>

<script>
import KeyboardMapConf from '../../theme/keyboard.map.json';
import { ToolsHandle } from '../../utils/tools.js';
// 命令数据功能操作对象
import { CommandHandle } from '../../utils/command_handle.js';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../asserts/js/hid_device.js';
import '../../asserts/css/box/tgl.css';

import buttonPaneC from '../../theme/templates/t1/components/buttonTabPane/buttonPaneC.vue'
export default {
  name: 'tgl',
  components: 
  { 
    buttonPaneC
  },
  data() {
    return {
      setButton:"",
      md5:"",
      funcName:"",
      c1:"",
      k0:false,
      k1:false,
      delay:100
    }
  },
  methods: 
  {
    editFunc(md5,name,task)
    {
      let context = this;
      var customObjs =  task.split("|");

      var taskObj1 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObjs[0]);
      var delay = parseInt(customObjs[1]);
      //更新UI
      this.setButton = customObjs[customObjs.length-1];
      this.md5 = md5;
      this.funcName = name;
      this.c1 = taskObj1.Value;
      this.delay = delay;
      
    },
    handleKeydownKey(e)
    {
        let key = ToolsHandle.getKeyObj(e);
        this.setButton = key.keyName;

        e.preventDefault();
        return false;
    },
    handleKeydown(e)
    {
        let key = ToolsHandle.getKeyObj(e);
        this.c1 = key.keyName;

        e.preventDefault();
        return false;
    },
    setDelay(val)
    {
      this.delay = val==0?1:val;
    },
    
    k0Focus(event)
    {
      this.k0 = true;
      this.k1 = false;
    },
    k1Focus(event)
    {
      this.k0 = false;
      this.k1 = true;
    },
    setKey(keyName)
    {
        if(this.k1)
        {
           this.c1 = keyName;
           this.$refs.k1.focus();
        }
        else if(this.k0)
        {
          this.setButton = keyName;
          this.$refs.key.focus();
        }
    }

  }
}
</script>